<template>
  <div class="report-header">
    <div class="report-title">
      <span class="logo"></span>
      <span class="title">{{title}}</span>
    </div>
    <div class="report-button-warpper">
      <div
        v-for="(item, $index) in buttons"
        :key="$index"
        style="display: inline-block;vertical-align: center;padding-left: 5px;padding-right: 5px;"
      >
        <el-button
          v-if="item.event.type === 'download'"
          class="download btn-font" size="small"
          type="primary" >
          <i class="iconfont icon-daochu"></i>
          <a :href="BASE_API + item.event.path"
             :download="item.event.fileName">
          </a>{{item.name}}
        </el-button>
        <fe-upload
          v-else-if="item.event.type === 'upload'"
          :event="item.event"
          :code="code"
          :downloadUrl="item.event.downloadUrl"
          :downloadName="item.event.downloadName"
          :buttonName="item.name"
          :downLoadTitle="item.event.downLoadTitle"
          :fileType="item.event.fileType"
          :path="item.event.path ">
        </fe-upload>
        <el-button
          v-else
          :type="getButtonType(item.event)"
          @click.stop="clickButton(item.event, $index, item.name)"
          :key="$index"
          v-waves
          size="small" class="btn-font">
          <i class="iconfont"
            :class="getClass(item.event, item.icon, item.name)"
          ></i>
          <label>{{item.name}}</label>
        </el-button>
      </div>
      <el-dialog
        :title="title"
        :visible.sync="showDialog"
        modal-append-to-body
        width="50%"
        center>
        <report
          v-bind="meta"
          :isDialog="inDialog"
          code="name"
          ref="customdialogReport"
          @radioChecked="radioCheckedMethod"
          @checkbox="getCheckedReport"
        ></report>
        <div class="button-operator-area">
          <el-button @click.native="reset">取 消</el-button>
          <el-button type="primary" @click.native="getDialgMethod">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-button
        v-for="(item, $index) in buttons"
        :type="getButtonType(item.event)"
        @click.stop="clickButton(item.event)"
        :key="$index"
        size="small">
        {{item.name}}
      </el-button> -->
    </div>
  </div>
</template>
<script>
  import commonMixin from '@/mixins/common.js'
  import columnMixin from '@/mixins/columnsMixin'
  import waves from '@/directive/waves/index.js'
  import FeUpload from '@/components/FromBase/upload/index'
  // import _ from 'lodash'
/* eslint-disable */
  export default {
    name: 'report-header',
    mixins: [commonMixin, columnMixin],
    directives: {
      waves
    },
    props: {
      title: {
        type: String
      },
      code: {
        type: String
      },
      buttons: {
        type: Array
      },
      isDialog: {
        required: false
      },
      radioCheckedValue: {
        type: Object
      },
      checkeboxChecked: {
        type: Array
      }
    },
    data() {
      return {
        BASE_API: process.env.BASE_API,
        withCredentials: true
      }
    },
    components:{
      FeUpload
    },
    methods: {
      // clickButton(event, index, $event) {
      clickButton(event, index, name) {
        const script = event.script
        switch (event.type) {
          case 'router':
            if (event.configKey) {
              event.path = '/config/' + encodeURIComponent(event.configKey)
            }
            let obj = {
              path: event.path
            }
            // 临时修改，后期通过增加后台配置判断
            if(process.env.PROJECT === 'dealer_pc' && /logistics_add_select/.test(event.configKey)){
                obj.query = {}
                obj.query._ = Date.now()
            }
            if(process.env.PROJECT === 'outlet') {
              if (this.$route.path.split('.')[1] === 'json') {
                obj.query = {}
                obj.query.crumb = name
                if (event.static && event.static.method) {
                  obj.query.method = event.static.method
                }
              }
            }
            this.$router.push(obj)
            break
          case 'cancel':
              this.goBack()
            break
          case 'custom':
            if (~script.indexOf('function')) {
              const Fn = Function
              new Fn('return ' + script)()()
            } else {
              window[script] && window[script]()
            }
            break
          case 'dialog-report':
            if (!_.isEmpty(this.radioCheckedValue) || !this.checkeboxChecked.length <= 0) {
              this.buttonIndex = index
              if (!_.isEmpty(this.radioCheckedValue)) {
                this.showReport(event, this.radioCheckedValue, index)
              } else {
                this.showReport(event, this.checkeboxChecked, index)
              }
            } else {
              this.$message.warning('请选择')
            }
            break
          default:
            this.$emit('button-method', event, this.isDialog)
            break
        }
      },
      getDialgMethod() {
        if (!_.isEmpty(this.radioCheckedValue)) {
          this.sure(this.radioCheckedValue)
        } else {
          this.sureInHeader(this.checkeboxChecked)
        }
      },
      getButtonType(item, index) {
        if (item.type === 'router' || item.type === 'ajax' || item.type === 'submit' || item.type === 'add' || item.type === 'import' || item.type === 'batchUpdate' ||
          item.type === 'ajaxBatchUpdate' || item.type === 'saveToForm' || item.type === 'saveToRep' || item.type ===
          'alternative' || item.type === 'reset' || item.type === 'export' || item.type === 'yongHongExport' || item.type === 'feExport') {
          return 'primary'
        }
      },
      // 上传成功
      uploadSuccess() {
        this.$nextTick(() => {
          this.$bus.$emit('refresh-grid')
        })
      },
      // 上传文件失败
      uploadError(err) {
        console.error('上传失败',err)
      },
      getClass(item,icon,name) {
        if(icon){
          return icon;
        }
        let retClass = null
        switch (item.type) {
          case 'dialog-report':
            retClass = 'icon-changjingguanli'
            break
          case 'router':
            retClass = 'icon-tianjia2'
            break
          case 'submit':
            retClass = 'icon-chaxun'
            if(name === '保存') {
                retClass = 'icon-baocun'
            }
            break
          case 'export':
            retClass = 'icon-daochu'
            break
          case 'reset':
            retClass = 'icon-shuaxin1'
            break
          case 'custom':
            retClass = 'icon-gongnengdingyi'
            break
          case 'batch':
            retClass = 'icon-yunyingguanli'
            break
          case 'yongHongExport':
            retClass = 'icon-daochu'
            break
          case 'feExport':
            retClass = 'icon-daochu'
            break
          case 'cancel':
            retClass = 'icon-fanhui'
            break
          default:
            retClass = 'icon-tupianjiazaishibai'
            break
        }
        return retClass
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .el-dialog__header{
    padding-top: 0px;
  }
  .button-operator-area{
    float: right;
    display: inline-block;
    margin-bottom:18px;
    .el-button {
      display: block;
      float: right;
      &:first-child{
        margin-left: 10px;
      }
    }
  }
  .report-header {
    width: 100%;
    height:50px;
    background-color:#fff;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    border-bottom: 1px solid #d8dce5;
  .report-title {
    padding-left:20px;
    float: left;
    line-height:50px;
    white-space: nowrap;
    font-size:0px;
  .title {
    display:inline-block;
    font-size: 15px;
    white-space: nowrap;
    vertical-align:middle;
    padding-left:10px;
    color:#666;
  }
  .logo {
    display:inline-block;
    background-color:#25adfb;
    white-space: nowrap;
    width:2px;
    border-radius:2px;
    height:16px;
    display: inline-block;
    position: relative;
    left: 0;
    vertical-align:middle;
  }

  }
  .report-button-warpper {
    float: right;
    line-height:48px;
    padding-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    button{
      display: flex;
      flex: 1;
      align-items: center;
    }
  }
  .download{
      position: relative;
      a{
        line-height: 30px;
        position: absolute;
        text-align: center;
        top: 0px;
        left: 0;
        bottom: 0;
        right: 0;
      }
  }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/components/reportHeader.vue